// extracted by mini-css-extract-plugin
module.exports = {"sx95k36":"sx95k36","opwm90d":"opwm90d","w18prfcn":"w18prfcn","l1pb8pl2":"l1pb8pl2","b1dj9fcr":"b1dj9fcr","c1o730d4":"c1o730d4","g1q5g8u9":"g1q5g8u9"};